import { render, staticRenderFns } from "./CreateDiscountModal.vue?vue&type=template&id=1e4e9652"
import script from "./CreateDiscountModal.vue?vue&type=script&lang=js"
export * from "./CreateDiscountModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports